module.exports = __webpack_public_path__ + "static/media/BraunLogoColored.7566a65d.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/BraunLogoColored.png
// module id = 6800
// module chunks = 0